var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('v-subtitle',{attrs:{"zh":"常见问题","en":"Q&A","type":"mini"}}),_c('v-problems',{attrs:{"data":_vm.problems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }